// Returns the correlation between two arrays. This method is the translation
// of Pearson's correlation for a sample found in:
// https://en.wikipedia.org/wiki/Pearson_correlation_coefficient#For_a_sample
export function computeCorrelation(xs, ys, asPercentage=true) {
  if(xs.length !== ys.length) { return 0 }
  // Compute the total sum of each array
  const xsTotal = xs.reduce((acc, x) => acc + x, 0)
  const ysTotal = ys.reduce((acc, x) => acc + x, 0)

  // Compute the mean for each array
  const xsMean = xsTotal/xs.length
  const ysMean = ysTotal/ys.length

  // Compute the arrays' covariance
  const covariance = xs.reduce((acc, x, i) => acc + (x - xsMean) * (ys[i] - ysMean), 0)

  // If the covariance is equal to 0, then correlation is equal to 0 as well
  if(covariance === 0) { return 0 }

  // Compute the standard error for both arrays
  const xsStandardError = Math.sqrt(
    xs.reduce((acc, x) => acc + Math.pow((x - xsMean), 2), 0)
  )
  const ysStandardError = Math.sqrt(
    ys.reduce((acc, y) => acc + Math.pow((y - ysMean), 2), 0)
  )

  // Compute correlation, optionally transform it to a percentage
  const correlation = covariance / (xsStandardError * ysStandardError)
  if(asPercentage) {
    return correlation * 100
  } else {
    return correlation
  }
}

// export function computeCorrelation(xs, ys, asPercentage=true) {
//       var sx = 0.0;
//       var sy = 0.0;
//       var sxx = 0.0;
//       var syy = 0.0;
//       var sxy = 0.0;
//       var n = xs.length;
//       for(var i = 0; i < n; i += 1) {
//         var x = xs[i];
//         var y = ys[i];
//         sx += x;
//         sy += y;
//         sxx += x * x;
//         syy += y * y;
//         sxy += x * y;
//       }
//       // covariation
//       var cov = sxy / n - sx * sy / n / n;
//       // standard error of x
//       var sigmaX = Math.sqrt(sxx / n -  sx * sx / n / n);
//       // standard error of y
//       var sigmaY = Math.sqrt(syy / n -  sy * sy / n / n);
//       // correlation is just a normalized covariation
//       return cov / sigmaX / sigmaY * 100;
// }